module.exports = __webpack_public_path__ + "static/media/history.28612511.svg";